<div class="bg-white min-h-screen">
    <!-- Hero Section -->
    <div class="bg-app-background-20 py-16 border-b border-gray-200">
        <div class="max-w-4xl mx-auto px-6">
            <h1 class="text-4xl font-fraunce text-app-primary-20 mb-4">Impressum</h1>
            <p class="text-app-secondary-10 text-xl">Angaben gemäß § 5 TMG</p>
        </div>
    </div>

    <!-- Content -->
    <div class="max-w-4xl mx-auto px-6 py-16">
        <div class="grid grid-cols-1 gap-12">

            <section class="prose max-w-none">
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">Aliacura e.K.</h2>
                <div class="text-app-secondary-10 space-y-1">
                    <p>Patriacura ist eine Marke der Aliacura e.K.</p>
                    <p>Dr. Philipp Hohnstein</p>
                    <p>Hauptstraße 4</p>
                    <p>91443 Scheinfeld</p>
                    <p>Deutschland</p>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">Handelsregister</h2>
                <div class="text-app-secondary-10">
                    <p>HRA 11249</p>
                    <p>Registergericht: Amtsgericht Fürth</p>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">Kontakt</h2>
                <div class="text-app-secondary-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <p class="font-medium">Telefon</p>
                        <p>09162 7103</p>
                    </div>
                    <div>
                        <p class="font-medium">Telefax</p>
                        <p>09841 2297</p>
                    </div>
                    <div class="sm:col-span-2">
                        <p class="font-medium">E-Mail</p>
                        <p>info&#64;patriacura.de</p>
                    </div>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">Umsatzsteuer-ID</h2>
                <div class="text-app-secondary-10">
                    <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:</p>
                    <p class="font-mono bg-gray-50 px-3 py-1 rounded inline-block mt-2 text-app-primary-20">DE297740030</p>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">Berufshaftpflichtversicherung</h2>
                <div class="text-app-secondary-10 space-y-2">
                    <p class="font-medium">Nürnberger Versicherung</p>
                    <p>Ostendstraße 100, 90334 Nürnberg</p>
                    <p>Telefon: +49 911 531-5 | Fax: +49 911 531-3206</p>
                    <p class="text-sm italic mt-2">Geltungsraum der Versicherung: weltweit mit Ausnahme von USA und Kanada</p>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">Verantwortlich für den Inhalt</h2>
                <div class="text-app-secondary-10">
                    <p>Verantwortlich nach § 55 Abs. 2 RStV:</p>
                    <p>Dr. Philipp Hohnstein</p>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">Streitschlichtung</h2>
                <div class="text-app-secondary-10 space-y-4">
                    <div>
                        <h3 class="font-medium mb-1">EU-Streitschlichtung</h3>
                        <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:</p>
                        <a href="https://ec.europa.eu/consumers/odr/" target="_blank" class="text-app-primary-10 hover:underline">https://ec.europa.eu/consumers/odr/</a>
                    </div>
                    <div>
                        <h3 class="font-medium mb-1">Verbraucherstreitbeilegung</h3>
                        <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
                    </div>
                </div>
            </section>

            <section>
                <h2 class="text-2xl font-semibold text-app-primary-20 mb-4 border-b pb-2">Rechtliche Hinweise</h2>
                <div class="text-app-secondary-10 space-y-6">
                    <div>
                        <h3 class="font-medium mb-1">Verantwortlichkeit ärztlicher Leistungen</h3>
                        <p>Die Aliacura e.K. betreibt ausschließlich das technische Arztportal. Die auf dieser Plattform präsentierten ärztlichen Leistungen werden eigenverantwortlich von den jeweils aufgeführten Ärztinnen und Ärzten erbracht. Die rechtliche Verantwortung für die Inhalte liegt ausschließlich bei den jeweiligen Leistungserbringern.</p>
                    </div>
                    <div>
                        <h3 class="font-medium mb-1">Haftung für Inhalte</h3>
                        <p>Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.</p>
                    </div>
                    <div>
                        <h3 class="font-medium mb-1">Urheberrecht</h3>
                        <p>Die durch die Aliacura e.K. erstellten Inhalte und Werke auf dieser Plattform unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung.</p>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>
